const initialValues = {
    name: "",
    email: "",
    phone: "",
    state: "",
  };
  
  export default initialValues;